import React, { Component } from "react";
import { Container, Row, Col, Card, Jumbotron } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import base_URL from "../base_URL";
import { Redirect } from "react-router-dom";
import { CardBody, CardList } from "reactstrap";
import { Grid } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";

const postThemeSuccess = () => {
  toast.success("Successfully send");
};

const postThemeError = (e) => {
  toast.error(e);
};

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      input: [],
      userService: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getTodos = this.getTodos.bind(this);
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({
      input,
      abc: [],
    });
  }

  ResetForm = () => {
    document.getElementById("form").reset();
  };

  handleSubmit(event) {
    event.preventDefault();

    let theme = this.state.input["theme"];

    axios
      .post(`${base_URL}/neededTheme/suggestion/${theme}`)

      .then(
        (response) => {
          this.ResetForm();
          postThemeSuccess();
        },
        (error) => {
          postThemeError(error);
        }
      );

      this.setState({
        input:[]
      })
  }

  getTodos = async () => {
    await axios.get(`${base_URL}/theme/all`, {}).then((response) => {
      this.setState({
        userService: response.data,
      });
    });
  };

  componentDidMount() {
    this.getTodos();
  }

  render() {
    if (localStorage.getItem("token") == null) return <Redirect to="/login" />;
    return (
      <Container id="container" className="homediv">
        <ToastContainer />
        <Jumbotron style={{ color: "black" }}>
          <h3 class="display-4">About</h3>

          <h4>
            Are you looking for some services and need some help.
            <br />
            <br />
            Relocator will help you to contact with persons who are good at
            there work, You will will be geeting suggestion from those who are using it.

            
          </h4> 
        </Jumbotron>
        <div className="grid">
            {this.state.userService.map((i, id) => {
              return (
                <Chip
                  id="chipview"
                  avatar={<Avatar>{i.themeName[0]}</Avatar>}
                  label={i.themeName}
                  variant="outlined"
                  color="primary"
                />
              );
            })}
          </div>

        <Card
          style={{
            margin: "20px",
            boxShadow:
              "-3px -3px 7px #ffffff73,2px 2px 5px rgba(129, 133, 139, 0.288)",
            padding: "20px",
            maring: "20px",
          }}
        >
          <h3 class="display-5">Request for new theme here</h3>
         
          
          
          <form onSubmit={this.handleSubmit} id="form">
            <Row>
              <Col>
                <div class="form-group">
                 
                  <input
                    required
                    type="text"
                    name="theme"
                    class="form-control"
                    placeholder="Enter Theme" 
                    value={this.state.input["theme"]}
                    onChange={this.handleChange}
                    id="theme"
                  />
                </div>
              </Col>
              <Col>
                <input type="submit" value="Send" class="btn btn-outline-primary" />
              </Col>
            </Row>
          </form>
        </Card>
        
      </Container>
    );
  }
}

export default Home;
